export function cleanTextValue(text: string | undefined | null): string {
    if (!text) return "";
    return text
      .replace(/,\s*null\s*,?/gi, "")
      .replace(/\bnull\b/gi, "")
      .replace(/,\s*,/g, ",")
      .replace(/^\s*,|,\s*$/g, "")
      .replace(/\s{2,}/g, "")       
      .trim();
  }
  

  export function cleanWebsiteURL(url: string | undefined | null): string {
    if (!url) return "";
    return url.replace(/^https?:\/\//i, "").trim();
  }
  